var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "grid grid-cols-1 mt-0 lg:grid-cols-2 gap-6 w-full"
  }, [_c('div', {
    staticClass: "bg-white border border-gray-100 rounded-2xl p-6 shadow-sm flex flex-col justify-start relative"
  }, [_c('div', [_c('h2', {
    staticClass: "text-xl font-bold text-gray-900 mb-6"
  }, [_vm._v("Awareness")]), !_vm.isAwarenessEmpty ? _c('div', {
    staticClass: "grid grid-cols-3 gap-4 mb-0"
  }, _vm._l(_vm.awarenessMetrics, function (metric, idx) {
    return _c('div', {
      key: idx
    }, [_c('div', {
      staticClass: "text-gray-400 mb-1"
    }, [metric.type === 'install' ? _c('svg', {
      staticClass: "w-7 h-7 text-gray-500 dark:text-white",
      attrs: {
        "aria-hidden": "true",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "fill": "currentColor",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M13 11.15V4a1 1 0 1 0-2 0v7.15L8.78 8.374a1 1 0 1 0-1.56 1.25l4 5a1 1 0 0 0 1.56 0l4-5a1 1 0 1 0-1.56-1.25L13 11.15Z",
        "clip-rule": "evenodd"
      }
    }), _c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M9.657 15.874 7.358 13H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2.358l-2.3 2.874a3 3 0 0 1-4.685 0ZM17 16a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H17Z",
        "clip-rule": "evenodd"
      }
    })]) : metric.type === 'apps' ? _c('svg', {
      staticClass: "w-7 h-7 text-gray-500 dark:text-white",
      attrs: {
        "aria-hidden": "true",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "fill": "currentColor",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M7.5 4.586A2 2 0 0 1 8.914 4h6.172a2 2 0 0 1 1.414.586L17.914 6H19a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h1.086L7.5 4.586ZM10 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z",
        "clip-rule": "evenodd"
      }
    })]) : metric.type === 'onsite' ? _c('svg', {
      staticClass: "w-7 h-7 text-gray-500 dark:text-white",
      attrs: {
        "aria-hidden": "true",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "fill": "currentColor",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M5 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4Zm12 12V5H7v11h10Zm-5 1a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z",
        "clip-rule": "evenodd"
      }
    })]) : _vm._e()]), _c('p', {
      staticClass: "text-base text-gray-500 font-medium"
    }, [_vm._v(_vm._s(metric.label))]), _c('h3', {
      staticClass: "text-2xl font-bold text-gray-900"
    }, [_vm._v(_vm._s(metric.value))])]);
  }), 0) : _vm._e()]), _c('div', {
    staticClass: "w-full"
  }, [_vm.isLoadingSummary ? _c('div', {
    staticClass: "absolute h-full bg-white inset-0 bg-white/70 z-10 flex items-center justify-center rounded-xl"
  }, [_c('div', {
    staticClass: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center"
  }, [_c('svg', {
    staticClass: "h-26 w-16 animate-spin text-blue-600 mb-4",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('circle', {
    staticClass: "opacity-25",
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 2 A 10 10 0 0 1 22 12",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })])])]) : _vm._e(), _vm.isAwarenessEmpty ? _c('div', {
    staticClass: "flex h-36 justify-center w-full flex-col items-center space-y-2 rounded-xl"
  }, [_vm._m(0), _c('p', {
    staticClass: "text-sm text-center font-medium text-gray-800"
  }, [_vm._v("No Data Yet")])]) : _vm._e(), _c('div', {
    staticClass: "w-full"
  }, [_c('apexchart', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isAwarenessEmpty,
      expression: "!isAwarenessEmpty"
    }],
    staticClass: "w-full",
    attrs: {
      "type": "bar",
      "height": "120",
      "options": _vm.awarenessChartOptions,
      "series": _vm.awarenessSeries
    }
  })], 1)])]), _c('div', {
    staticClass: "bg-white border border-gray-100 rounded-2xl p-6 shadow-sm relative flex flex-col justify-start"
  }, [_c('h2', {
    staticClass: "text-xl font-bold text-gray-900 mb-3"
  }, [_vm._v("Acquisition")]), _vm.isLoadingFunnel ? _c('div', {
    staticClass: "absolute h-full bg-white inset-0 bg-white/70 z-10 flex items-center justify-center rounded-xl"
  }, [_c('div', {
    staticClass: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center"
  }, [_c('svg', {
    staticClass: "h-26 w-16 animate-spin text-blue-600 mb-4",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('circle', {
    staticClass: "opacity-25",
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 2 A 10 10 0 0 1 22 12",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })])])]) : _vm._e(), _c('div', {
    staticClass: "relative w-full h-[240px] flex items-center justify-center"
  }, [_vm.isAcquisitionEmpty ? _c('div', {
    staticClass: "flex h-36 justify-center w-full flex-col items-center space-y-2 rounded-xl"
  }, [_vm._m(1), _c('p', {
    staticClass: "text-sm text-center font-medium text-gray-800"
  }, [_vm._v("No Data Yet")])]) : _vm._e(), _c('apexchart', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isAcquisitionEmpty,
      expression: "!isAcquisitionEmpty"
    }],
    staticClass: "w-full",
    attrs: {
      "type": "bar",
      "height": "240",
      "options": _vm.funnelChartOptions,
      "series": _vm.funnelSeries
    }
  })], 1)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('img', {
    staticClass: "w-12",
    attrs: {
      "src": require("../../assets/img/empty_smartpin.png"),
      "alt": ""
    }
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('img', {
    staticClass: "w-12",
    attrs: {
      "src": require("../../assets/img/empty_smartpin.png"),
      "alt": ""
    }
  })]);
}]

export { render, staticRenderFns }